var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangePasswordIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.1665 17.3333C2.1665 14.2697 2.1665 12.7368 3.11875 11.7856C4.06992 10.8333 5.60284 10.8333 8.6665 10.8333H17.3332C20.3968 10.8333 21.9298 10.8333 22.8809 11.7856C23.8332 12.7368 23.8332 14.2697 23.8332 17.3333C23.8332 20.397 23.8332 21.9299 22.8809 22.8811C21.9298 23.8333 20.3968 23.8333 17.3332 23.8333H8.6665C5.60284 23.8333 4.06992 23.8333 3.11875 22.8811C2.1665 21.9299 2.1665 20.397 2.1665 17.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.8333V8.66667C6.49844 7.08349 7.07474 5.55417 8.12074 4.36574C9.16673 3.17732 10.6105 2.4115 12.1811 2.21204C13.7516 2.01258 15.341 2.39318 16.6509 3.28241C17.9607 4.17164 18.901 5.50836 19.2953 7.04167",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6665 17.3333H8.67625M12.9901 17.3333H12.9998M17.3234 17.3333H17.3332",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePasswordIcon);
export default __webpack_public_path__ + "static/media/ChangePasswordIcon.6fa119b80362425c87d12f29d16b48e8.svg";
export { ForwardRef as ReactComponent };